import { RouteNames } from '@/types/routes.ts';
import type { RouteRecordRaw } from 'vue-router';
import { Feature } from '@/featureflag_manager.ts';

const routes: RouteRecordRaw[] = [
  {
    path: 'applications',
    name: RouteNames.APPLICATIONS_HOME,
    meta: {
      feature_flag: Feature.APPLICATION_ACCESS_MANAGEMENT,
    },
    component: () => import('./views/ListApplications.vue'),
  },
];

export default routes;
